import React from 'react';

import { ContributionFrequency } from './EnrollmentDetailsContributions.types';
import { useGetWeekDayName, useOrderNumberPostfix } from './hooks';

interface Props {
  frequency: ContributionFrequency;
  recurringDay: number;
}
const EnrollmentDetailsContributionsFrequencies: React.FC<Props> = ({ frequency, recurringDay }) => {
  const dayNumber = useOrderNumberPostfix(recurringDay);
  const weekDay = useGetWeekDayName(recurringDay);
  if (frequency === ContributionFrequency.MONTHLY) {
    return `Monthly, Every ${dayNumber} day`;
  }
  if (frequency === ContributionFrequency.WEEKLY) {
    return `Weekly, Every ${weekDay}`;
  }
  if (frequency === ContributionFrequency.BI_WEEKLY) {
    return `Bi-weekly, Every second ${weekDay}`;
  }
  return '';
};

export default EnrollmentDetailsContributionsFrequencies;
